module.exports = __webpack_public_path__ + "img/mobile_bg.ee21849b.png";